export const customerPaths = {
  '/customers/register': {
    post: {
      summary: 'Register a new customer',
      operationId: 'registerCustomer',
      tags: ['Customers'],
      security: [],
      requestBody: {
        required: true,
        content: {
          'application/json': {
            schema: {
              $ref: '#/components/schemas/CustomerRegister',
            },
            example: {
              auth_user_id: "fbabadab-2341-4fd0-aeab-b253bcbdf1cf"
            }
          },
        },
      },
      responses: {
        '201': {
          description: 'Customer registered successfully',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/Customer',
              },
              example: {
                id: 123,
                auth_user_id: "fbabadab-2341-4fd0-aeab-b253bcbdf1cf",
                is_email_confirmed: false,
                created_at: "2024-04-22T16:01:53.094Z",
                updated_at: "2024-04-22T16:01:53.094Z",
              }
            },
          },
        },
        '400': {
          description: 'Invalid request - missing required fields',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/ErrorResponse',
              },
              example: {
                error: 'Invalid request',
                details: 'Missing required field: auth_user_id'
              }
            },
          },
        },
        '409': {
          description: 'Customer with this auth_user_id already exists',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/ErrorResponse',
              },
              example: {
                error: 'Registration failed',
                details: 'This Supabase user already has a customer record'
              }
            },
          },
        },
        '500': {
          description: 'Internal server error',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/ErrorResponse',
              },
              example: {
                error: 'Registration failed',
                details: 'An error occurred while creating your account'
              }
            },
          },
        },
      },
    },
  },
  '/customers/login': {
    post: {
      summary: 'Login as a customer',
      operationId: 'loginCustomer',
      tags: ['Customers'],
      security: [],
      requestBody: {
        required: true,
        content: {
          'application/json': {
            schema: {
              $ref: '#/components/schemas/CustomerLogin',
            },
            example: {
              auth_user_id: "fbabadab-2341-4fd0-aeab-b253bcbdf1cf"
            }
          },
        },
      },
      responses: {
        '200': {
          description: 'Login successful',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/Customer',
              },
              example: {
                id: 123,
                auth_user_id: "fbabadab-2341-4fd0-aeab-b253bcbdf1cf",
                is_email_confirmed: false,
                created_at: "2024-04-22T16:01:53.094Z",
                updated_at: "2024-04-22T16:01:53.094Z",
              }
            },
          },
        },
        '400': {
          description: 'Invalid request - missing required fields',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/ErrorResponse',
              },
              example: {
                error: 'Invalid request',
                details: 'auth_user_id is required'
              }
            },
          },
        },
        '401': {
          description: 'Authentication failed',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/ErrorResponse',
              },
              example: {
                error: 'Authentication failed',
                details: 'Customer not found for this auth user'
              }
            },
          },
        },
      },
    },
  },
  '/customer-types': {
    get: {
      summary: 'List all customer types',
      operationId: 'listCustomerTypes',
      parameters: [
        {
          name: 'search',
          in: 'query',
          schema: {
            type: 'string',
          },
          description: 'Search term to filter customer types by name',
        },
        {
          name: 'limit',
          in: 'query',
          schema: {
            type: 'integer',
            default: 100,
          },
          description: 'Number of items to return',
        },
        {
          name: 'offset',
          in: 'query',
          schema: {
            type: 'integer',
            default: 0,
          },
          description: 'Number of items to skip',
        },
      ],
      responses: {
        '200': {
          description: 'A list of customer types',
          content: {
            'application/json': {
              schema: {
                type: 'array',
                items: {
                  $ref: '#/components/schemas/CustomerType',
                },
              },
            },
          },
        },
      },
    },
    post: {
      summary: 'Create a new customer type',
      operationId: 'createCustomerType',
      requestBody: {
        required: true,
        content: {
          'application/json': {
            schema: {
              $ref: '#/components/schemas/CustomerType',
            },
          },
        },
      },
      responses: {
        '201': {
          description: 'The created customer type',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/CustomerType',
              },
            },
          },
        },
      },
    },
  },
  '/customer-types/{id}': {
    get: {
      summary: 'Get a customer type by ID',
      operationId: 'getCustomerType',
      parameters: [
        {
          name: 'id',
          in: 'path',
          required: true,
          schema: {
            type: 'integer',
          },
        },
      ],
      responses: {
        '200': {
          description: 'The requested customer type',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/CustomerType',
              },
            },
          },
        },
        '404': {
          description: 'Customer type not found',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/ErrorResponse',
              },
            },
          },
        },
      },
    },
    put: {
      summary: 'Update a customer type',
      operationId: 'updateCustomerType',
      parameters: [
        {
          name: 'id',
          in: 'path',
          required: true,
          schema: {
            type: 'integer',
          },
        },
      ],
      requestBody: {
        required: true,
        content: {
          'application/json': {
            schema: {
              $ref: '#/components/schemas/CustomerType',
            },
          },
        },
      },
      responses: {
        '200': {
          description: 'The updated customer type',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/CustomerType',
              },
            },
          },
        },
      },
    },
    delete: {
      summary: 'Delete a customer type',
      operationId: 'deleteCustomerType',
      parameters: [
        {
          name: 'id',
          in: 'path',
          required: true,
          schema: {
            type: 'integer',
          },
        },
      ],
      responses: {
        '204': {
          description: 'Customer type deleted successfully',
        },
      },
    },
  },
  '/customers': {
    post: {
      summary: 'Create a new customer',
      operationId: 'createCustomer',
      tags: ['Customers'],
      security: [
        { serviceAccountApiKey: [] }
      ],
      parameters: [
        {
          name: 'x-api-key',
          in: 'header',
          required: true,
          schema: {
            type: 'string'
          },
          description: 'Service Account API Key (required for external apps)'
        }
      ],
      requestBody: {
        required: true,
        content: {
          'application/json': {
            schema: {
              type: 'object',
              required: ['email', 'first_name', 'last_name'],
              properties: {
                email: { type: 'string', format: 'email', example: 'person@domain.com' },
                first_name: { type: 'string', example: 'Alice' },
                last_name: { type: 'string', example: 'Smith' },
                auth_user_id: { type: 'string', format: 'uuid', description: 'Linked Supabase Auth User ID', example: 'fbabadab-2341-4fd0-aeab-b253bcbdf1cf' }
              }
            },
            example: {
              email: "person@domain.com",
              first_name: "Alice",
              last_name: "Smith",
              auth_user_id: "fbabadab-2341-4fd0-aeab-b253bcbdf1cf"
            }
          }
        }
      },
      responses: {
        '201': {
          description: 'Customer created successfully',
          content: {
            'application/json': {
              schema: {
                $ref: '#/components/schemas/Customer',
              },
              example: {
                id: 123,
                email: "person@domain.com",
                first_name: "Alice",
                last_name: "Smith",
                auth_user_id: "fbabadab-2341-4fd0-aeab-b253bcbdf1cf",
                created_at: "2024-04-22T16:01:53.094Z",
                updated_at: "2024-04-22T16:01:53.094Z",
              }
            }
          }
        },
        '400': {
          description: 'Missing required fields or invalid data',
          content: {
            'application/json': {
              schema: { $ref: '#/components/schemas/ErrorResponse' },
              example: { error: 'Missing required fields: email, first_name, and last_name are required' }
            }
          }
        },
        '401': {
          description: 'Unauthorized: Invalid or missing API key',
          content: {
            'application/json': {
              schema: { $ref: '#/components/schemas/ErrorResponse' },
              example: { error: 'Unauthorized', details: 'Invalid or missing API key' }
            }
          }
        },
        '409': {
          description: 'Email already registered',
          content: {
            'application/json': {
              schema: { $ref: '#/components/schemas/ErrorResponse' },
              example: { error: 'Email already registered' }
            }
          }
        }
      },
      description: 'Creates a new customer. This endpoint can be accessed by external applications using a Service Account API Key in the x-api-key header.'
    },
    get: {
      summary: 'List all customers',
      operationId: 'listCustomers',
      tags: ['Customers'],
      security: [],
      responses: {
        '200': {
          description: 'A list of customers',
          content: {
            'application/json': {
              schema: {
                type: 'array',
                items: { $ref: '#/components/schemas/Customer' }
              }
            }
          }
        }
      }
    }
  },

  '/customers/{id}': {
    get: {
      summary: 'Get customer by ID',
      operationId: 'getCustomerById',
      tags: ['Customers'],
      parameters: [
        {
          name: 'id',
          in: 'path',
          schema: { type: 'integer' },
          required: true,
          description: 'Customer ID'
        }
      ],
      responses: {
        '200': {
          description: 'Customer details',
          content: {
            'application/json': {
              schema: { $ref: '#/components/schemas/Customer' }
            }
          }
        },
        '404': {
          description: 'Customer not found',
          content: {
            'application/json': {
              schema: { $ref: '#/components/schemas/ErrorResponse' }
            }
          }
        }
      }
    },
    patch: {
      summary: 'Update a customer',
      operationId: 'updateCustomer',
      tags: ['Customers'],
      security: [
        { serviceAccountApiKey: [] }
      ],
      parameters: [
        {
          name: 'id',
          in: 'path',
          schema: { type: 'integer' },
          required: true,
          description: 'Customer ID'
        },
        {
          name: 'x-api-key',
          in: 'header',
          required: true,
          schema: {
            type: 'string'
          },
          description: 'Service Account API Key (required for external apps)'
        }
      ],
      requestBody: {
        required: true,
        content: {
          'application/json': {
            schema: {
              type: 'object',
              properties: {
                email: { type: 'string', format: 'email', example: 'person@domain.com' },
                first_name: { type: 'string', example: 'Alice' },
                last_name: { type: 'string', example: 'Smith' },
                auth_user_id: { type: 'string', format: 'uuid', description: 'Linked Supabase Auth User ID', example: 'fbabadab-2341-4fd0-aeab-b253bcbdf1cf' }
              }
            },
            example: {
              email: "newemail@domain.com",
              first_name: "Alicia",
              last_name: "Smithson"
            }
          }
        }
      },
      responses: {
        '200': {
          description: 'Customer updated successfully',
          content: {
            'application/json': {
              schema: { $ref: '#/components/schemas/Customer' },
              example: {
                id: 123,
                email: "newemail@domain.com",
                first_name: "Alicia",
                last_name: "Smithson",
                auth_user_id: "fbabadab-2341-4fd0-aeab-b253bcbdf1cf",
                created_at: "2024-04-22T16:01:53.094Z",
                updated_at: "2024-04-23T10:00:00.000Z",
              }
            }
          }
        },
        '400': {
          description: 'Missing required fields or invalid data',
          content: {
            'application/json': {
              schema: { $ref: '#/components/schemas/ErrorResponse' },
              example: { error: 'Invalid JSON in request body' }
            }
          }
        },
        '401': {
          description: 'Unauthorized: Invalid or missing API key',
          content: {
            'application/json': {
              schema: { $ref: '#/components/schemas/ErrorResponse' },
              example: { error: 'Unauthorized', details: 'Invalid or missing API key' }
            }
          }
        },
        '404': {
          description: 'Customer not found',
          content: {
            'application/json': {
              schema: { $ref: '#/components/schemas/ErrorResponse' },
              example: { error: 'Customer not found' }
            }
          }
        }
      },
      description: 'Updates an existing customer by ID. This endpoint can be accessed by external applications using a Service Account API Key in the x-api-key header.'
    },
    delete: {
      summary: 'Delete customer by ID',
      operationId: 'deleteCustomer',
      tags: ['Customers'],
      parameters: [
        {
          name: 'id',
          in: 'path',
          schema: { type: 'integer' },
          required: true,
          description: 'Customer ID'
        }
      ],
      responses: {
        '204': { description: 'Customer deleted' },
        '404': {
          description: 'Customer not found',
          content: {
            'application/json': {
              schema: { $ref: '#/components/schemas/ErrorResponse' }
            }
          }
        }
      }
    }
  },
};

// Define security scheme for service accounts at the bottom if not already defined
export const customerSecuritySchemes = {
  serviceAccountApiKey: {
    type: 'apiKey',
    in: 'header',
    name: 'x-api-key',
    description: 'Service Account API Key (generated via admin tools for automation/external apps)',
  }
};
